const fileNameElmt = document.getElementById('filename')
export default () => fileNameElmt && fileNameElmt.value
